import React, { useState, useRef } from "react";
import { DropzoneAreaBase } from "mui-file-dropzone";

import {
  Grid,
  Box,
  Typography,
  Button,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";

import {
  trakrefFontFamily,
  trakrefFontFamilyBold,
  trakrefFontFamilySemiBold,
} from "../../utils";
import { Grey2, Grey3, trakrefBlue } from "../../color_utils";
import { CommonModal } from "../../components/Common";

const initialState = {
  value: "",
  isVisible: false,
};

/* const useStyles = makeStyles({
  notes: { marginTop: "4%", width: "65%" },
  submitButton: {
    backgroundColor: "#008299",
    color: "#fff",
    fontSize: "16px",
    width: "62%",
    marginBottom: "4%",
    padding: "2% 0%",
  },
  closeButton: { position: "absolute", right: 0, top: 0 },
  title: {
    textAlign: "center",
    marginTop: "4%",
    fontSize: "22px",
    font: "Open Sans",
    fontWeight: "600",
    color: "#1B2125",
  },
  dropzone: { width: "100%", height: "20px", border: "1.5px dashed gray;" },
  actionButtons: { margin: "4% 0%", justifyContent: "center" },
  dropzoneParagraph: {
    fontSize: "1.05rem",
    marginTop: "20% !important",
    marginBottom: "10% !important",
  },
  uploadIcon: { color: "#008299", fontSize: "2.9rem" },
}); */

const ColoredUploadIcon = () => (
  <FileUploadOutlinedIcon
    fontSize="large"
    sx={{
      color: trakrefBlue,
      marginTop: "25px",
    }}
  />
);

const UserAddBulkModal = ({ modalOpen, onClose, Guid }) => {
  // const classes = useStyles();
  const dropzoneRef = useRef();
  const [fileUploaded, setFileUploaded] = useState(null);

  return (
    <CommonModal open={modalOpen} close={onClose} header={"Bulk Import Users"}>
      <Grid container pl={10} pr={10} gap={1}>
        <div style={{ textAlign: "center" }}>
          <span
            style={{
              fontSize: "13px",
              display: "inline-block",
              fontFamily: trakrefFontFamilySemiBold,
            }}
          >
            Use an{" "}
            <span
              style={{
                color: trakrefBlue,
                textDecoration: "underline",
              }}
            >
              Excel template (.xls or .xlsx)
            </span>{" "}
            with data entered on a worksheet titled « Users ». The first row of
            the file is ignored for column titles.
          </span>
        </div>
        <Grid item xs={12} lg={12}>
          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "10px",
              padding: "10px",
            }}
          >
            <DropzoneAreaBase
              showPreviewsInDropzone={false}
              showAlerts={false}
              onAdd={(fileObjs) => {
                console.log({ fileObjs })
                setFileUploaded(fileObjs[0])
              }}
              dropzoneProps={{
                ref: dropzoneRef,
              }}
              filesLimit={1}
              Icon={ColoredUploadIcon}
              dropzoneText=""
            />
            <div
              style={{
                position: "absolute",
                top: "110px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "0px",
              }}
            >
              <span
                sx={{
                  fontFamily: trakrefFontFamilySemiBold,
                  color: Grey2,
                  fontSize: 15,
                  letterSpacing: "1px",
                }}
              >
                Drag and Drop a file here
              </span>
              <span
                style={{
                  fontFamily: trakrefFontFamilySemiBold,
                  color: Grey2,
                  fontSize: 13,
                }}
              >
                or
              </span>
            </div>
            <Button
              variant="outlined"
              size="small"
              style={{
                fontSize: "14px !important",
              }}
              sx={{
                borderColor: trakrefBlue,
                borderWidth: "1.5px",
                color: trakrefBlue,
                fontFamily: trakrefFontFamily,
                letterSpacing: "1.5px",
                fontWeight: "600",
                marginBottom: "20px",
                position: "absolute",
                bottom: "60px",
                background: "transparent",
              }}
              onClick={() => dropzoneRef.current.open()}
            >
              BROWSE FILES
            </Button>
          </Box>
          {fileUploaded && (
            <span
              style={{
                color: Grey3,
                fontSize: "12px",
                marginLeft: "10px",
              }}
            >
              {`${fileUploaded.file.name} - ${fileUploaded.file.size} bytes`}
            </span>
          )}
        </Grid>
        <Grid item xs={12} lg={12} align="center">
          <Box mt={2} mb={2} sx={{ width: "100%" }}>
            <LoadingButton
              fullWidth
              size="large"
              variant="contained"
              sx={{
                "& .MuiCircularProgress-root": {
                  color: "#FFFFFF",
                  width: "21px !important",
                  height: "21px !important",
                },
              }}
              style={{
                backgroundColor: trakrefBlue,
              }}
            >
              <Typography
                sx={{
                  fontFamily: trakrefFontFamilyBold,
                  color: "#FFF",
                  backgroundColor: trakrefBlue,
                  letterSpacing: "1.2px",
                  padding: "1% 0%",
                  color: false ? "transparent" : "#fff",
                  fontSize: 17,
                  fontWeight: 400,
                }}
              >
                Upload
              </Typography>
            </LoadingButton>
          </Box>
        </Grid>
      </Grid>
    </CommonModal>
  );
};

export default UserAddBulkModal;
